export const CpRoutes = {
  RealtimeDashboard: 'reporting/realtime-dashboard',
  HistoricDashboard: 'reporting/historic-dashboard',
  ReportBuilder: 'reporting/report-builder',
  TransportDashboard: 'reporting/transport-dashboard',
  PaxonDashboard: 'reporting/paxon-dashboard',
  NewDashboard: 'reporting/new-dashboard',
  PurchaseOrderDetails: 'inbound/po-details',
  PurchaseOrderDetailsInfo: 'inbound/po-details/info',
  PurchaseOrderDetailsGraph: 'inbound/po-details/graph',
  OrderDetails: 'outbound/order-details',
  OrderDetailsGraph: 'outbound/order-details/graph',
  OrderDetailsInfo: 'outbound/order-details/info',
  OrdersOnHold: 'outbound/orders-on-hold',
  Kitting: 'outbound/kitting',
  KittingOrderDetail: 'outbound/kitting/kitting-order-details',
  KittingOrdersImport: 'outbound/kitting/import-kitting-orders',
  OrdersOnHoldInfo: 'outbound/orders-on-hold/order-details',
  OrdersOnHoldAmendOrder: 'outbound/orders-on-hold/amend-order',
  OrdersOnHoldBlockRequests: 'outbound/orders-on-hold/block-requests',
  Forecast: 'forecast',
  SitePlanningForecast: 'forecast/site-planning',
  VolumeForecast: 'forecast/volume-planning',
  PeakForecast: 'forecast/peak-planning',
  SitePlanningForecastSearch: 'forecast/search/site-planning',
  VolumeForecastSearch: 'forecast/search/volume-planning',
  PeakForecastSearch: 'forecast/search/peak-planning',
  OntimeShipSLA: 'outbound/on-time-ship-sla',
  OntimeShipSLAGraph: 'outbound/on-time-ship-sla/graph',
  OntimeShipSLAList: 'outbound/on-time-ship-sla/list',
  ReturnDetails: 'return/return-details',
  ReturnDetailsGraph: 'return/return-details/graph',
  InventoryDetails: 'inventory/inventory-details',
  InventoryDetailsInfo: 'inventory/inventory-details/info',
  Parameter: 'config/parameter',
  UserConfig: 'config/user-config',
  ClientConfig: 'config/client-config',
  InquiryDesk: 'client-inquiry/list',
  OrderCancel: null,
  TrackandTrace: null,
  AddItem: 'outbound/order-details/add-item',
  EditItem: null,
  CancelItem: null,
  DownloadCommercialInvoices: null,
  ProductCategory: null,
  NewRealTimeDashboard: '/landingpage/realtimedashboard',
  NewHistoricDashboard: '/landingpage/histdashboard',
  NewDashboardFilterOptions: '/landingpage/getfilters',
  OmniSearchAPI: '/landingpage/omnisearch',
  ChangeAddressAcronym: 'CHNGADRS',
  FcSiteAcronym: 'FCSITE',
  FcVolumeAcronym: 'FCVOLUME',
  FcPeakAcronym: 'FCPEAK',
  AddItemAcronym: 'ADD',
  // CS pre-arrival order block: actions under Orders on hold (OOH)
  BlockRequestsAcronym: 'OOHBLKREQ',
  BlockOrdersAcronym: 'OOHBLKORD',
};
